import global from "./global.json";

export const sv = {
  global,
};
